export const LIGHTING = "Lighting";
export const WORK_ORDERS = "WorkOrders";
export const PIR_ID = "PIR_ID";
export const RESET_SENSOR_BASELINE = "RESET_SENSOR_BASELINE";
